import './App.css';

import { Link, Route, BrowserRouter as Router, Switch } from 'react-router-dom';

import { ActionLine } from './components/ActionLine/ActionLine';
import { ExampleBlock } from './components/ExampleBlock/ExampleBlock';
import { Footer } from './components/Footer/Footer';
import { Header } from './components/Header/Header';
import { Intro } from './components/Intro/Intro';
import React from 'react';
import { Started } from './components/Started/Started';

function App() {
    return (
        <Router>
            <div className="wrapper">
                <Header />

                <Switch>
                    <Route path="/started">
                        <Started />
                    </Route>
                    <Route path="/">
                        <Intro />
                        <ActionLine />
                        <ExampleBlock />
                    </Route>
                </Switch>

                <Footer />
            </div>
        </Router>
    );
}

export default App;
